import { PushNotifications } from '@capacitor/push-notifications';
import { App as CapacitorApp } from '@capacitor/app';
import NotificationsNotBlockMobile from '@/components/notificationsNotBlock/NotificationsNotBlockMobile.vue';
import axios from 'axios';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    pendingAction: null,
    appStateChangeEvent: false,
    firebaseEvent: false,
    requestGetLastUnsend: false,
    lastHandledKey: null,
  },
  getters: {
    firebaseEvent: (state) => state.firebaseEvent,
    appStateChangeEvent: (state) => state.appStateChangeEvent,
    requestGetLastUnsend: (state) => state.requestGetLastUnsend,
  },

  actions: {
    async initPush({ dispatch }) {
      await dispatch('addPushNotificationListeners');
      await dispatch('addWebNotificationListeners');
    },

    async addPushNotificationListeners({ state, dispatch, rootState, getters, commit }) {
      if (getters.firebaseEvent) return;

      const handlePayload = async (payload) => {
        if (!payload || typeof payload !== 'object') return;

        const key = JSON.stringify(payload);
        if (state.lastHandledKey === key) return;
        state.lastHandledKey = key;

        try {
          state.requestGetLastUnsend = true;

          await dispatch('checkPayloadActionNative', payload);

          const iin = rootState?.auth?.user?.iin;
          if (iin) {
            await axios.get('/push-notification/get-last-unsend-web-push-and-mark-as-send', {
              params: { iin },
            });
          }
        } catch (e) {
          console.error('[pushNotifications] handlePayload error:', e);
        } finally {
          state.requestGetLastUnsend = false;
        }
      };

      const actionPerformed = PushNotifications.addListener(
        'pushNotificationActionPerformed',
        async (event) => {
          const payload = event?.notification?.data || null;
          await handlePayload(payload);
        }
      );

      const restored = CapacitorApp.addListener('appRestoredResult', async (result) => {
        if (result?.pluginId === 'PushNotifications') {
          const payload = result?.data?.notification?.data || null;
          await handlePayload(payload);
        }
      });

      commit('SET_FIREBASE_EVENT', { actionPerformed, restored });
    },

    async addWebNotificationListeners({ dispatch, getters, commit }) {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      dispatch('getLastUnsendWebPushAndMarkAsSend');

      if (!getters.appStateChangeEvent) {
        const event = CapacitorApp.addListener('appStateChange', ({ isActive }) => {
          if (isActive) {
            dispatch('getLastUnsendWebPushAndMarkAsSend');
          }
        });

        commit('SET_APP_STATE_CHANGE_EVENT', event);
      }
    },

    async getLastUnsendWebPushAndMarkAsSend({ state, getters, rootState }) {
      if (getters.requestGetLastUnsend) return;

      state.requestGetLastUnsend = true;

      try {
        const iin = rootState?.auth?.user?.iin;
        if (!iin) return;

        const response = await axios.get('/push-notification/get-last-unsend-web-push-and-mark-as-send', {
          params: { iin },
        });

        if (response?.data?.data !== false) {
          const item = response.data.data;

          const options = {
            position: 'top-center',
            icon: true,
            transition: 'my-custom-transition',
            hideProgressBar: true,
            timeout: 10000,
            toastClassName: 'my-custom-toast-class-common',
            bodyClassName: ['custom-class-1', 'custom-class-2'],
          };

          Vue.$toast(
            {
              component: NotificationsNotBlockMobile,
              props: {
                id: item.id,
                title: item.title,
                content: item.content,
                payload: item.payload,
              },
            },
            options
          );
        }
      } catch (e) {
        console.error('[pushNotifications] getLastUnsend error:', e);
      } finally {
        state.requestGetLastUnsend = false;
      }
    },

    async checkPayloadActionWeb({ dispatch }, { payload }) {
      if (payload && typeof payload === 'object' && 'action' in payload) {
        await dispatch('startAction', { action: payload.action, data: payload });
      }
    },

    async checkPayloadActionNative({ dispatch, commit, rootGetters }, payload) {
      console.log(payload)
      if (payload && typeof payload === 'object' && 'action' in payload) {
        const action = payload.action;

        if (!rootGetters['auth/authenticated']) {
          commit('SET_PENDING_ACTION', payload);
          return;
        }

        await dispatch('startAction', { action, data: payload });
      }
    },

    async startAction({ dispatch }, { action, data }) {
      switch (action) {
        case 'openChat':
          await dispatch('openChat', { payload: data });
          break;
        default:
          break;
      }
    },

    async openChat({ dispatch }, { payload }) {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      if ('chatId' in payload) {
        await dispatch('newChat/setPreSelectedChatId', payload.chatId, { root: true });
        await dispatch('newChat/openNewChatModal', null, { root: true });
      } else {
        console.warn('[pushNotifications] openChat: missing chatId');
      }
    },

    async resolvePendingAction({ state, commit, dispatch }) {
      if (state.pendingAction) {
        await dispatch('openChat', { payload: state.pendingAction });
        commit('CLEAR_PENDING_ACTION');
      }
    },
  },

  mutations: {
    SET_FIREBASE_EVENT(state, value) {
      state.firebaseEvent = value;
    },
    SET_APP_STATE_CHANGE_EVENT(state, value) {
      state.appStateChangeEvent = value;
    },
    SET_PENDING_ACTION(state, value) {
      state.pendingAction = value;
    },
    CLEAR_PENDING_ACTION(state) {
      state.pendingAction = null;
    },
  },
};
